import { useQuery } from "react-query";
import SchemaService from "../api/services/SchemaService";

export const useBondOptionsSchema = (queryKey: string) => {
  const { data, isLoading, refetch, isError, error } = useQuery(queryKey, async () =>
    await SchemaService.getBondOptionsSchema()
  );

  return {
    bondOptionsSchema: data?.data?.schema,
    isBondOptionsSchemaLoading: isLoading,
    bondOptionsSchemaError: error,
    isBondOptionsSchemaError: isError,
    fetchBondOptionsSchema: refetch
  }
}